module.exports = __webpack_public_path__ + "static/media/02_aviara-burnaby.5a381343.jpg";